(function () {
    'use strict';

    angular.module('app').run(['swaggerModules', 'swagger2JsonParser', appRun]);

    function appRun(swaggerModules, swagger2JsonParser) {
        swaggerModules.add(swaggerModules.PARSE, swagger2JsonParser);
    }
})();